import http from '../../plugins/axios';

export default {

    getList(data) {
        return http.get({
            url: '/admin/reconciliation/list',
            data
        });
    },

    getReconConf(data) {
        return http.get({
            url: '/admin/reconciliation/conf/list',
            data
        })
    },

    saveReconConf(data) {
        return http.post({
            url: '/admin/reconciliation/conf/save',
            data,
            dataType: 'form'
        })
    },

    reconciliationManual(data) {
        return http.post({
            url: '/admin/reconciliation/manual',
            data,
            dataType: 'form'
        })
    },

    queryWalletReconciliationList(data) {
        return http.get({
            url: '/admin/wallet/reconciliation/list',
            data
        })
    },

    exportWalletReconciliationList(data) {
        return http.get({
            url: '/admin/wallet/reconciliation/export',
            data,
            responseType: 'blob'
        })
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },

    getAllSupportReconciliationCoin() {
        return http.get({
            url: '/admin/wallet/reconciliation/getAllSupportReconciliationCoin'
        });
    },

    saveNeedReconciliationCoin(data) {
        return http.post({
            url: '/admin/wallet/reconciliation/saveNeedReconciliationCoin',
            data
        });
    }
}
